import { Link, useLocation, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Layout from '../../components/common/pageLayout'
import './fat.css'
import constant from '../../constant';
import Ships from '../../components/FAT/ProjectFATList/ships';
import { useEffect, useState } from 'react';
import { v3_fat_list, v3_fat_project_ships, v3_fat_Status_Update } from '../../actions/v3/fat';
import Fat from '../../components/FAT/ProjectFATList/fat';
import Filter from '../../components/FAT/ProjectFATList/filter';
import { toast } from 'react-toastify';
import ExportColumnModal from '../../components/common/ExportColumnModal';
import { appendDateRangeToFileName, exportRowsToExcel, getSessionStorage, setSessionStorage } from '../../utils';

const ACCEPTED_REPORT_RECEIVED_STATUS = 'Accepted, Report received';
const ACCEPTED_REPORT_RECIEVED_STATUS = 'Accepted, Report recieved';

const formatFatStatusForExport = (status) => {
    if (status === 'Accepted' || status === ACCEPTED_REPORT_RECIEVED_STATUS) {
        return ACCEPTED_REPORT_RECEIVED_STATUS;
    }
    return status;
};

const fatExportColumns = [
    { key: 'id', label: 'ID', value: (item) => item.ID },
    { key: 'subject', label: 'Subject', value: (item) => item.SUBJECT },
    { key: 'fatNumber', label: 'FAT Number', value: (item) => `${item.FAT_NUMBER} (${item.HULL_NUMBER} - ${item.SHIP_NAME})` },
    { key: 'projectName', label: 'Project Name', value: (item) => item.PROJECT_NAME },
    { key: 'shipName', label: 'Ship Name', value: (item) => item.SHIP_NAME },
    { key: 'hullNumber', label: 'Hull Number', value: (item) => item.HULL_NUMBER },
    { key: 'categoryName', label: 'Category Name', value: (item) => item.CATEGORY_NAME },
    { key: 'channelId', label: 'Channel ID', value: (item) => item.CHANNEL_ID },
    { key: 'remark', label: 'Remark', value: (item) => item.REMARK },
    { key: 'status', label: 'Status', value: (item) => formatFatStatusForExport(item.STATUS) },
    { key: 'statusComment', label: 'Status Comment', value: (item) => item.STATUS_COMMENT || '' },
    { key: 'scheduledDate', label: 'Scheduled Date', value: (item) => item.SCHEDULE_DATE || '' },
    { key: 'totalComments', label: 'Total Comments', value: (item) => item.TOTAL_COMMENTS },
    { key: 'assignedTo', label: 'Assigned To', value: (item) => item.ASSIGNED_USER_NAME },
    { key: 'assigneeDesignation', label: 'Assignee Designation', value: (item) => item.ASSIGNED_USER_DESIGNATION_NAME },
    { key: 'companyName', label: 'Company Name', value: (item) => item.COMPANY_NAME },
    { key: 'createdBy', label: 'Created By', value: (item) => item.CREATED_BY_NAME },
    { key: 'createdOn', label: 'Created On', value: (item) => item.CREATED_ON },
    { key: 'modifiedOn', label: 'Modified On', value: (item) => item.MODIFIED_ON },
    { key: 'lastRevisionCreatedOn', label: 'Last Revision Created On', value: (item) => item.LAST_REVISION_CREATED_ON },
];

const getStoredSessionValue = (key, fallback) => {
    if (!key) return fallback;
    try {
        const storedValue = getSessionStorage(key);
        return storedValue ?? fallback;
    } catch (error) {
        return fallback;
    }
};

const Index = () => {

    const location = useLocation();
    const history = useHistory();
    const { projectId, projectName } = location.state || {};
    const filterStorageKey = projectId ? `iship:fat:project:${projectId}:filters` : '';
    const shipStorageKey = projectId ? `iship:fat:project:${projectId}:ship` : '';
    const [data, setData] = useState([]);

    const isPop = history.action === 'POP';

    const [shipsData, setShipsData] = useState(null);
    const [shipId, setShipId] = useState(() => {
        if (isPop) {
            return getStoredSessionValue(shipStorageKey, null);
        } else {
            if (shipStorageKey) setSessionStorage(shipStorageKey, null);
            return null;
        }
    });
    const [statusCount, setStatusCount] = useState(null);
    const [total, setTotal] = useState(0);
    const [filterPayload, setFilterPayload] = useState(() => {
        if (isPop) {
            return getStoredSessionValue(filterStorageKey, {});
        } else {
            if (filterStorageKey) setSessionStorage(filterStorageKey, {});
            return {};
        }
    });

    const [refresh, setRefresh] = useState(false)

    useEffect(() => {
        if (!projectId) return;
        v3_fat_project_ships(projectId).then((res) => {
            if (res.status) {
                setShipsData(res.result);
            }
        })
    }, [projectId, refresh])

    const onChangeFilter = (filterModel) => {
        setFilterPayload(filterModel)
        if (filterStorageKey) {
            setSessionStorage(filterStorageKey, filterModel);
        }
    }

    const onChangeShip = (nextShipId) => {
        setShipId(nextShipId);
        if (shipStorageKey) {
            setSessionStorage(shipStorageKey, nextShipId);
        }
    }

    const onUpdateStatus = (payload) => {
        v3_fat_Status_Update(payload).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                setRefresh(!refresh)
                const modal = window.bootstrap.Modal.getInstance(document.getElementById(`statusUpdateModal`));
                if (modal) modal.hide();
            }
        })
    }

    const encodeFilterPayload = (payload) => {
        try {
            const json = JSON.stringify(payload);
            if (!json) return '';

            if (typeof TextEncoder !== 'undefined') {
                const bytes = new TextEncoder().encode(json);
                let binary = '';
                bytes.forEach((b) => {
                    binary += String.fromCharCode(b);
                });
                return btoa(binary);
            }

            // Fallback for older browsers.
            return btoa(unescape(encodeURIComponent(json)));
        } catch (error) {
            console.error('Failed to encode filter payload:', error);
            return '';
        }
    };

    const exportExcel = async (selectedColumns = fatExportColumns) => {
        let exportData = data || [];
        if (!exportData.length || (total && exportData.length < total)) {
            const pageSize = 1000;
            const encodedFilterPayload = encodeFilterPayload(filterPayload);
            const allResults = [];
            let page = 1;
            let expectedTotal = Number(total || 0);

            while (true) {
                // eslint-disable-next-line no-await-in-loop
                const res = await v3_fat_list(page, pageSize, projectId, shipId, encodedFilterPayload);
                if (!res?.status) {
                    break;
                }

                const pageRows = res?.result?.fat || [];
                expectedTotal = Number(res?.result?.total || expectedTotal || 0);
                allResults.push(...pageRows);

                if (pageRows.length === 0) break;
                if (expectedTotal > 0 && allResults.length >= expectedTotal) break;
                if (!expectedTotal && pageRows.length < pageSize) break;

                page += 1;
            }

            if (allResults.length) {
                exportData = allResults;
            }
        }

        if (!exportData.length) {
            alert("No Observation data to export");
            return;
        }

        exportRowsToExcel({
            rows: exportData,
            columns: selectedColumns,
            sheetName: "Observations",
            fileName: `${appendDateRangeToFileName('fat', filterPayload)}.xlsx`,
        });
    }
    if (!projectId) {
        return (
            <Layout title='FAT'>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="alert alert-warning mb-0">
                            Project context is missing. Please open FAT from the project list again.
                        </div>
                    </div>
                </div>
            </Layout>
        );
    }

    const selectedShip = Array.isArray(shipsData?.ships)
        ? shipsData.ships.find((item) => String(item?.SHIP_ID) === String(shipId))
        : null;
    const selectedHullLabel = selectedShip
        ? `${selectedShip.HULL_NUMBER} - ${selectedShip.SHIP_NAME}`
        : '';

    return (
        <Layout title={projectName ? `FAT | ${projectName}` : 'FAT'}>
            <div className="row">
                <div className="col-lg-12">
                    <div className="card" id={1}>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12 ">
                                    <Filter
                                        statusCount={statusCount}
                                        total={total}
                                        initialFilter={filterPayload}
                                        onChangeFilter={onChangeFilter}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">

                                    <Ships
                                        data={shipsData}
                                        shipId={shipId}
                                        setShipId={onChangeShip}
                                    />

                                </div>
                                <div className="col-md-9">

                                    <div className="inspection-title-box">
                                        <div className="inspection-one">FAT {selectedHullLabel ? `- ${selectedHullLabel}` : ""}</div>
                                        <div className="inspection-two">
                                            <button
                                                type="button"
                                                data-bs-toggle="modal"
                                                data-bs-target="#fat-export-columns-modal"
                                                className="btn btn-sm btn-primary me-2"
                                                style={{
                                                    backgroundImage:
                                                        "linear-gradient(90deg, rgb(104, 149, 180), rgb(38, 85, 120))"
                                                }}
                                            >
                                                <i className="mdi mdi-file-excel-outline label-icon" /> Export
                                            </button>
                                            <Link
                                                to={{
                                                    pathname: constant.Authedcomponent.fatCreate.url,
                                                    state: {
                                                        projectId
                                                    }
                                                }}
                                                className="btn btn-sm btn-primary me-2"
                                                style={{
                                                    backgroundImage:
                                                        "linear-gradient(90deg, rgb(104, 149, 180), rgb(38, 85, 120))"
                                                }}
                                            >
                                                <i className='fa fa-plus-circle me-1' />
                                                Create New

                                            </Link></div>
                                    </div>
                                    <Fat
                                        data={data}
                                        setData={setData}
                                        refresh={refresh}
                                        setRefresh={setRefresh}
                                        onUpdateStatus={onUpdateStatus}
                                        projectId={projectId}
                                        shipId={shipId}
                                        setTotal={setTotal}
                                        setStatusCount={setStatusCount}
                                        filterPayload={filterPayload}

                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ExportColumnModal
                modalId="fat-export-columns-modal"
                title="Select FAT Columns"
                columns={fatExportColumns}
                onExport={exportExcel}
            />

        </Layout>
    )
}

export default Index
